import React, { useState, useEffect, Fragment } from "react";
import Select from "react-select";
import CardField from "./CardField";
import CardForm, { FormType } from "./CardForm";
import CardGrid from "./CardGrid";
import Preview, { JsonPrint } from "../Preview";
import * as Styled from "./misc/styled";
import * as GlobalStyled from "../styled/form-fields";
import { v4 as uuid } from "uuid";
import sortBy from "lodash/sortBy";

const DEFAULT_VALUE = Object.freeze({
  category: "",
  title: "",
  description: "",
  cards: [],
  pageSize: 4,
});

const pageSizeOptions = [...new Array(20)].map((_, i) => ({
  value: i + 1,
  label: `${i + 1}`,
}));

const TileGridField = (props) => {
  const {
    input: { value, onChange },
  } = props;

  const [cardFormVisible, toggleCardFormVisibility] = useState(false);

  useEffect(() => {
    if (typeof value === "string") {
      onChange({ ...DEFAULT_VALUE });
    }
  }, []);

  const handleOnChange = ({ target }) => {
    const { name, type } = target;
    const val = type === "checkbox" ? target.checked : target.value;
    onChange({
      ...value,
      [name]: val,
    });
  };

  const handleOnSelect = (selected, { name }) => {
    onChange({
      ...value,
      [name]: parseInt(selected.value, 10),
    });
  };

  if (typeof value === "string") {
    return null;
  }

  const handleOnAdd = (data) => {
    const filtered = value.cards.filter((o) => o.id !== data.id);
    const newCard = { ...data, id: uuid() };
    const cards = [...filtered, newCard];

    onChange({
      ...value,
      cards,
    });
    toggleCardFormVisibility(false);
  };

  const handleOnShowForm = (data) => {
    if (data === null || data === undefined) {
      toggleCardFormVisibility({
        formData: null,
        formType: FormType.Create,
      });
      return;
    }

    toggleCardFormVisibility({ ...data });
  };

  const handleOnCancel = () => {
    toggleCardFormVisibility(false);
  };

  const handleOnDelete = (id) => {
    const cards = value.cards.filter((o) => o.id !== id);
    onChange({
      ...value,
      cards,
    });
  };

  const { category, title, description, cards, pageSize } = value;
  const pageSizeValue = pageSizeOptions.find((o) => o.value === pageSize);

  return (
    <section>
      <Preview>
        <CardGrid {...value} />
      </Preview>
      <JsonPrint disable data={value} />
      <GlobalStyled.FormField>
        <GlobalStyled.Label>Category</GlobalStyled.Label>
        <GlobalStyled.Input
          type="text"
          name="category"
          value={category}
          onChange={handleOnChange}
        />
      </GlobalStyled.FormField>
      <GlobalStyled.FormField>
        <GlobalStyled.Label>Title</GlobalStyled.Label>
        <GlobalStyled.Input
          type="text"
          name="title"
          value={title}
          onChange={handleOnChange}
        />
      </GlobalStyled.FormField>
      <div className="csod-awave-- csod-awave--field csod-awave--field--text">
        <label className="csod-awave--field__label">Description</label>
        <textarea
          name="description"
          value={description}
          onChange={handleOnChange}
        />
      </div>
      <div style={{ marginBottom: "16px" }}>
        <Styled.CardFieldHeader>
          <p className="header">
            {cardFormVisible ? "Card form" : `Cards (${cards.length})`}
          </p>
          <a
            role="button"
            className="add"
            onClick={
              cardFormVisible ? handleOnCancel : () => handleOnShowForm()
            }
          >
            {cardFormVisible ? "Cancel" : "Add"}
          </a>
        </Styled.CardFieldHeader>
        {cardFormVisible ? (
          <CardForm
            {...cardFormVisible}
            onAdd={handleOnAdd}
            onCancel={handleOnCancel}
          />
        ) : (
          <Fragment>
            {sortBy(cards, ["order", "title", "description"]).map((card) => (
              <CardField
                key={card.id}
                data={card}
                onShowForm={handleOnShowForm}
                onDelete={handleOnDelete}
              />
            ))}
          </Fragment>
        )}
      </div>
      <GlobalStyled.FormField>
        <GlobalStyled.Label>Page size</GlobalStyled.Label>
        <Select
          name="pageSize"
          value={pageSizeValue}
          onChange={handleOnSelect}
          options={pageSizeOptions}
        />
      </GlobalStyled.FormField>
    </section>
  );
};

export default TileGridField;



// WEBPACK FOOTER //
// ./src/core/admin/components/CardGrid/Field.js